module.exports = " <check-dialog></check-dialog> <care-header></care-header> <div class=container> <div class=main> <im-container :im-height=imHeight></im-container> </div> <order-container></order-container> </div> ";


//////////////////
// WEBPACK FOOTER
// ./~/vue-html-loader!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 56
// module chunks = 1